(function () {
  'use strict';
  function $(s, r) { return (r || document).querySelector(s); }
  function $all(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  var nt = $('.nav-toggle');
  if (nt) nt.addEventListener('click', function () {
    var n = $('.main-nav'); if (!n) return;
    var open = n.classList.toggle('open');
    nt.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  function refreshCart() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { $all('[data-cart-count]').forEach(function (e) { e.textContent = c.item_count; }); })
      .catch(function () {});
  }
  refreshCart();

  // Product gallery
  $all('[data-gallery]').forEach(function (g) {
    var main = $('[data-gallery-main]', g);
    if (!main) return;
    $all('[data-gallery-thumb]', g).forEach(function (t) {
      t.addEventListener('click', function () {
        main.src = t.getAttribute('data-full') || t.src;
        $all('[data-gallery-thumb]', g).forEach(function (x) { x.classList.remove('sel'); });
        t.classList.add('sel');
      });
    });
  });

  // Quantity stepper + volume-tier display
  $all('[data-buy-form]').forEach(function (form) {
    var input = $('[data-qty-input]', form);
    if (!input) return;
    var base = parseFloat(form.getAttribute('data-base-price')) || 0;
    var off2 = parseFloat(form.getAttribute('data-tier2-off')) || 0;
    var off3 = parseFloat(form.getAttribute('data-tier3-off')) || 0;
    function unit(q) { if (q >= 40) return base - off3; if (q >= 10) return base - off2; return base; }
    function draw() {
      var q = Math.max(1, parseInt(input.value, 10) || 1);
      input.value = q;
      var u = unit(q);
      var up = $('[data-unit-price]', form); if (up) up.textContent = '$' + u.toFixed(2);
      var lt = $('[data-line-total]', form); if (lt) lt.textContent = '$' + (u * q).toFixed(2);
      $all('[data-tier]', form).forEach(function (t) { t.classList.remove('active'); });
      var act = q >= 40 ? '3' : (q >= 10 ? '2' : '1');
      var el = $('[data-tier="' + act + '"]', form); if (el) el.classList.add('active');
      var note = $('[data-tier-note]', form);
      if (note) {
        if (q >= 40) note.textContent = '40+ club pricing \u2014 $' + off3.toFixed(2) + ' off each.';
        else if (q >= 10) note.textContent = '10+ team pricing \u2014 $' + off2.toFixed(2) + ' off each.';
        else note.textContent = 'Outfitting a squad? 10+ save $' + off2.toFixed(2) + ' each, 40+ save $' + off3.toFixed(2) + ' each.';
      }
    }
    var dec = $('[data-qty-dec]', form), inc = $('[data-qty-inc]', form);
    if (dec) dec.addEventListener('click', function () { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); draw(); });
    if (inc) inc.addEventListener('click', function () { input.value = (parseInt(input.value, 10) || 1) + 1; draw(); });
    input.addEventListener('input', draw);
    draw();
  });

  // Build-your-system picker
  var bs = $('[data-build]');
  if (bs) {
    var selVal = function (group) {
      var el = $('[data-group="' + group + '"] .opt.sel', bs);
      if (!el) return { name: '', price: 0, rf: true, needsRf: false };
      return {
        name: el.getAttribute('data-name'),
        price: parseFloat(el.getAttribute('data-price')) || 0,
        rf: el.getAttribute('data-rf') !== '0',
        needsRf: el.getAttribute('data-needs-rf') === '1'
      };
    };
    var render = function () {
      var t = selVal('timer'), b = selVal('board'), x = selVal('extra');
      var total = t.price + b.price + x.price;
      var list = $('[data-kit-list]', bs);
      if (list) { var h = t.name; if (b.price > 0) h += '<br>' + b.name; if (x.price > 0) h += '<br>' + x.name; list.innerHTML = h; }
      var tot = $('[data-kit-total]', bs); if (tot) tot.textContent = '$' + total.toFixed(2);
      var nn = $('[data-kit-note]', bs);
      var wireless = (b.needsRf ? b.name : '') || (x.needsRf ? x.name : '');
      var clash = !t.rf && wireless;
      if (nn) {
        nn.classList.toggle('warn', !!clash);
        if (clash) nn.textContent = t.name + ' has no radio, so it cannot drive the ' + wireless + '. Switch to an RF timer for wireless parts.';
        else if (b.price > 0) nn.textContent = 'Scoreboards use the RF link \u2014 we set matched IDs before shipping.';
        else nn.textContent = 'Add a scoreboard so the whole venue sees the clock.';
      }
    };
    $all('.opt', bs).forEach(function (el) {
      el.addEventListener('click', function () {
        var g = el.closest('[data-group]');
        $all('.opt', g).forEach(function (x) { x.classList.remove('sel'); });
        el.classList.add('sel');
        render();
      });
    });
    render();
  }
})();
